/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type VolunteerAssignedShiftsQueryVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Int"];
}>;

export type VolunteerAssignedShiftsQuery = {
  volunteerShiftSignups: Array<
    Pick<Types.ShiftSignup, "shift_id" | "checked_in"> & {
      shift: Pick<Types.EventActivity, "name" | "start_time" | "end_time">;
    }
  >;
};

export const VolunteerAssignedShiftsDocument = gql`
  query VolunteerAssignedShifts($event_attendee_id: Int!) {
    volunteerShiftSignups(
      where: { event_attendee_id: { equals: $event_attendee_id } }
    ) {
      shift_id
      checked_in
      shift {
        name
        start_time
        end_time
      }
    }
  }
`;

/**
 * __useVolunteerAssignedShiftsQuery__
 *
 * To run a query within a React component, call `useVolunteerAssignedShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerAssignedShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerAssignedShiftsQuery({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useVolunteerAssignedShiftsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VolunteerAssignedShiftsQuery,
    VolunteerAssignedShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    VolunteerAssignedShiftsQuery,
    VolunteerAssignedShiftsQueryVariables
  >(VolunteerAssignedShiftsDocument, baseOptions);
}
export function useVolunteerAssignedShiftsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VolunteerAssignedShiftsQuery,
    VolunteerAssignedShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    VolunteerAssignedShiftsQuery,
    VolunteerAssignedShiftsQueryVariables
  >(VolunteerAssignedShiftsDocument, baseOptions);
}
export type VolunteerAssignedShiftsQueryHookResult = ReturnType<
  typeof useVolunteerAssignedShiftsQuery
>;
export type VolunteerAssignedShiftsLazyQueryHookResult = ReturnType<
  typeof useVolunteerAssignedShiftsLazyQuery
>;
export type VolunteerAssignedShiftsQueryResult = ApolloReactCommon.QueryResult<
  VolunteerAssignedShiftsQuery,
  VolunteerAssignedShiftsQueryVariables
>;
